<script lang="ts">
  import Button from './ui/button.svelte';

  import { cn } from '$lib/utils';
  import type { AssetStoryblok, MultilinkStoryblok } from '$types/bloks';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import CmsImage from './cms-image.svelte';

  let className: string | undefined = undefined;
  export { className as class };

  export let title: string | undefined = undefined;
  export let image: AssetStoryblok;
  export let buttonLabel: string | undefined = undefined;
  export let href: MultilinkStoryblok | undefined = undefined;
</script>

{#if image.id}
  <svelte:element
    this={href?.id ? 'a' : 'div'}
    href={href ? $getAnchorFromCmsLink(href).href : undefined}
    class={cn(
      'group relative isolate flex aspect-[2/3] cursor-pointer flex-col justify-between overflow-hidden rounded-md p-4 h-full',
      className
    )}
    {...$$restProps}
  >
    <CmsImage
      {image}
      draggable="false"
      class="absolute inset-0 -z-10 h-full w-full select-none object-cover transition-transform duration-300 motion-safe:group-hover:scale-105"
    />
    {#if title}
      <h3 class="text-3xl font-semibold text-highlight">{title}</h3>
    {/if}

    {#if buttonLabel}
      <Button name={buttonLabel} variant="secondary" class="backdrop-blur">
        {buttonLabel}
      </Button>
    {/if}
  </svelte:element>
{/if}
